import { Controller } from "@hotwired/stimulus"

// Toggles a drop-shadow under the announcements modal's sticky header once its
// body has scrolled, so content sliding under the header reads as layered. The
// footer shadow is always-on (pure CSS); only the header shadow is scroll-aware.
export default class extends Controller {
  static targets = ["body"]

  connect() {
    this.update()
  }

  update() {
    this.element.classList.toggle("announcements--scrolled", this.bodyTarget.scrollTop > 0)
  }
}
